<template>
  <div class="page_five">
    <div class="wear_left"></div>
    <div class="wear_right"></div>
    <div class="wear_middle"></div>
    <div class="container">
      <transition enter-active-class="animate__animated animate__fadeInUp">
        <div v-show="pageIndex == 4">
          <p class="p1">START YOUR OWN</p>
          <p class="p2">LAND</p>
        </div>
      </transition>
      <div class="bottom">
        <img src="@/assets/img/lvtiao.png" alt="" />
        <p class="p3">
          Each land will have its own particular ecology. The corresponding
          local specialists, construction materials and other resources in the
          land will be produced, and the priority access to these resources is
          owned by the Landlord.
        </p>
        <div class="btn">VIEW MORE</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "",
  computed: {
    ...mapState({
      pageIndex: (state) => state.page.pageIndex,
    }),
  },
};
</script>
<style scoped lang="scss">
.page_five {
  position: relative;
  width: 100%;
  // height: 1154px;
  height: 1254px;
  background: url("~@/assets/img/beijing3.png") center top no-repeat;
  // background-position: center -50px;
  .wear_left {
    z-index: 2;
    width: 342px;
    height: 1154px;
    position: absolute;
    top: 0;
    left: 0;
    background: url("~@/assets/img/side_wear1.png") repeat-y;
  }
  .wear_right {
    z-index: 2;
    width: 342px;
    height: 1154px;
    position: absolute;
    top: 0;
    right: 0;
    background: url("~@/assets/img/side_wear.png") repeat-y;
  }
  .wear_middle {
    z-index: 3;
    position: absolute;
    left: 0;
    bottom: 0px;
    // transform: translateY(15%);
    width: 100%;
    height: 909px;
    background: url("~@/assets/img/middle_wear.png") repeat-x;
  }
  .container {
    position: relative;
    z-index: 4;
    width: 987px;
    height: 432px;
    position: absolute;
    // top: 690px;
    top: 490px;
    left: 5rem;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: icomoon;
    color: #fff;
    .p1 {
      // width: 722px;
      height: 57px;
      opacity: 0.6;
      font-size: 80px;
      font-weight: 700;
      text-align: center;
    }
    .p2 {
      text-align: center;
      margin-top: 25px;
      font-size: 87px;
      font-weight: 700;
      color: #fff;
    }
    .bottom {
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 101px;
        height: 3px;
        margin-top: 38px;
      }
      .p3 {
        margin-top: 35px;
        width: 987px;
        height: 76px;
        font-size: 24px;
        text-align: center;
      }
      .btn {
        cursor: pointer;
        margin-top: 48px;
        width: 344px;
        height: 80px;
        border: 3px solid #bbbbbb;
        border-radius: 4px;
        font-size: 40px;
        font-weight: 700;
        text-align: center;
        line-height: 80px;
      }
    }
  }
}

@media (max-width: 1199px) {
  .page_five {
    margin-top: 1.333333rem;
    position: relative;
    width: 100vw;
    height: 12.72rem;
    background: url("~@/assets/img/beijing3.png") center top no-repeat;
    background-size: 10.506667rem 5.36rem;
    .wear_left {
      z-index: 2;
      width: 2.266667rem;
      height: 7.68rem;
      position: absolute;
      top: 0;
      left: 0;
      background: url("~@/assets/img/side_wear1.png") repeat-y;
      background-size: 2.266667rem 0.853333rem;
    }
    .wear_right {
      z-index: 2;
      width: 2.266667rem;
      height: 7.68rem;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/img/side_wear.png") center bottom repeat-y;
      background-size: 2.266667rem 0.853333rem;
    }
    .wear_middle {
      z-index: 3;
      position: absolute;
      left: 0;
      bottom: 4.2rem;
      width: 100%;
      height: 6.08rem;
      background: url("~@/assets/img/middle_wear.png") repeat-x;
      background-size: 0.853333rem 6.08rem;
    }
    .container {
      position: relative;
      z-index: 4;
      width: 13.146667rem;
      height: 5.76rem;
      position: absolute;
      top: 6.186667rem;
      left: 5rem;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: icomoon;
      color: #fff;
      .p1 {
        margin-top: -2.133333rem;
        width: 9.626667rem;
        height: 0.773333rem;
        opacity: 0.6;
        font-size: 0.533333rem;
        font-weight: 700;
        text-align: center;
      }
      .p2 {
        text-align: center;
        margin-top: -0.133333rem;
        font-size: 0.586667rem;
        font-weight: 700;
        color: #fff;
      }
      .bottom {
        position: absolute;
        bottom: 3.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 1.52rem;
          height: 0.053333rem;
          margin-top: 0rem;
        }
        .p3 {
          margin-top: 0.48rem;
          width: 10rem;
          height: 76px;
          font-size: 0.32rem;
          text-align: center;
        }
        .btn {
          cursor: pointer;
          margin-top: 1.1rem;
          width: 2.293333rem;
          height: 0.533333rem;
          border: 2px solid #bbbbbb;
          border-radius: 4px;
          font-size: 0.373333rem;
          font-weight: 700;
          text-align: center;
          line-height: 0.533333rem;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .page_five {
    margin-top: 1.333333rem;
    position: relative;
    width: 100vw;
    height: 12.72rem;
    background: url("~@/assets/img/beijing3.png") center top no-repeat;
    background-size: 10.506667rem 5.36rem;
    .wear_left {
      z-index: 2;
      width: 2.266667rem;
      height: 7.68rem;
      position: absolute;
      top: 0;
      left: 0;
      background: url("~@/assets/img/side_wear1.png") repeat-y;
      background-size: 2.266667rem 0.853333rem;
    }
    .wear_right {
      z-index: 2;
      width: 2.266667rem;
      height: 7.68rem;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/img/side_wear.png") center bottom repeat-y;
      background-size: 2.266667rem 0.853333rem;
    }
    .wear_middle {
      z-index: 3;
      position: absolute;
      left: 0;
      bottom: 4.2rem;
      width: 100%;
      height: 6.08rem;
      background: url("~@/assets/img/middle_wear.png") repeat-x;
      background-size: 0.853333rem 6.08rem;
    }
    .container {
      position: relative;
      z-index: 4;
      width: 13.146667rem;
      height: 5.76rem;
      position: absolute;
      top: 6.186667rem;
      left: 5rem;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: icomoon;
      color: #fff;
      .p1 {
        margin-top: -2.133333rem;
        width: 9.626667rem;
        height: 0.773333rem;
        opacity: 0.6;
        font-size: 0.533333rem;
        font-weight: 700;
        text-align: center;
      }
      .p2 {
        text-align: center;
        margin-top: -0.133333rem;
        font-size: 0.586667rem;
        font-weight: 700;
        color: #fff;
      }
      .bottom {
        position: absolute;
        bottom: 3.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 1.52rem;
          height: 0.053333rem;
          margin-top: 0rem;
        }
        .p3 {
          margin-top: 0.48rem;
          width: 10rem;
          height: 76px;
          font-size: 0.32rem;
          text-align: center;
        }
        .btn {
          cursor: pointer;
          margin-top: 1.1rem;
          width: 2.293333rem;
          height: 0.533333rem;
          border: 2px solid #bbbbbb;
          border-radius: 4px;
          font-size: 0.373333rem;
          font-weight: 700;
          text-align: center;
          line-height: 0.533333rem;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page_five {
    margin-top: 1.333333rem;
    position: relative;
    width: 100vw;
    height: 12.72rem;
    background: url("~@/assets/img/beijing3.png") center top no-repeat;
    background-size: 10.506667rem 5.36rem;
    .wear_left {
      z-index: 2;
      width: 2.266667rem;
      height: 7.68rem;
      position: absolute;
      top: 0;
      left: 0;
      background: url("~@/assets/img/side_wear1.png") repeat-y;
      background-size: 2.266667rem 0.853333rem;
    }
    .wear_right {
      z-index: 2;
      width: 2.266667rem;
      height: 7.68rem;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/img/side_wear.png") center bottom repeat-y;
      background-size: 2.266667rem 0.853333rem;
    }
    .wear_middle {
      z-index: 3;
      position: absolute;
      left: 0;
      bottom: 4.2rem;
      width: 100%;
      height: 6.08rem;
      background: url("~@/assets/img/middle_wear.png") repeat-x;
      background-size: 0.853333rem 6.08rem;
    }
    .container {
      position: relative;
      z-index: 4;
      width: 13.146667rem;
      height: 5.76rem;
      position: absolute;
      top: 6.186667rem;
      left: 5rem;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: icomoon;
      color: #fff;
      .p1 {
        margin-top: -2.133333rem;
        width: 9.626667rem;
        height: 0.773333rem;
        opacity: 0.6;
        font-size: 0.533333rem;
        font-weight: 700;
        text-align: center;
      }
      .p2 {
        text-align: center;
        margin-top: -0.133333rem;
        font-size: 0.586667rem;
        font-weight: 700;
        color: #fff;
      }
      .bottom {
        position: absolute;
        bottom: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 1.52rem;
          height: 0.053333rem;
          margin-top: 0rem;
        }
        .p3 {
          margin-top: 0.3rem;
          width: 10rem;
          height: 76px;
          font-size: 0.32rem;
          text-align: center;
        }
        .btn {
          cursor: pointer;
          margin-top: 0.1rem;
          width: 4rem;
          height: 0.96rem;
          border: 1px solid #bbbbbb;
          border-radius: 4px;
          font-size: 0.373333rem;
          font-weight: 700;
          text-align: center;
          line-height: 0.96rem;
        }
      }
    }
  }
}
</style>
